import React, { memo } from "react";
import PropTypes from "prop-types";
import emailLogo from "../../assets/email-logo.png";
import "./Auth.css";

function AuthView({
  email,
  setEmail,
  password,
  setPassword,
  error,
  onSignInClick,
}) {
  return (
    <div className="auth-container">
      <h2>Sign In</h2>

      <div className="auth-field">
        <label htmlFor="auth_email">Email</label>
        <input
          id="auth_email"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="auth-field">
        <label htmlFor="auth_password">Password</label>
        <input
          id="auth_password"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      <button
        className="email-sign-in"
        onClick={onSignInClick}
        disabled={!email || !password}
      >
        <img
          src={emailLogo}
          alt="Email Icon"
          className="email-logo"
        />
        <span>Sign in with Email</span>
      </button>

      {error && <div className="auth-error">{error}</div>}
    </div>
  );
}

AuthView.propTypes = {
  email: PropTypes.string.isRequired,
  setEmail: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  setPassword: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  onSignInClick: PropTypes.func.isRequired,
};

export default memo(AuthView);
